import {URL_VENTA_VOUCHER} from "../../../api/config";
import makeQuery, {cleanObj} from "../../../api/helper";

export default {
  namespaced: true,
  state: {
    vouchers: [],
    filtros: {
      folio: null,
      fecha: "",
      estado: "",
      tipo_venta: "",
      cliente_rut: "",
      vendedor: ""
    },
    limite: 40,
    offset: 0,
    currentPage: 1,
    isLoading: false
  },
  mutations: {
    "SET_VOUCHERS"(state, payload) {
      state.vouchers = payload
    },
    "SET_FILTROS"({filtros}, payload = {}) {
      filtros[payload.key] = payload.data
    },
    "NEXT_PAGE"(state) {
      state.currentPage++
      state.offset = state.limite * (state.currentPage - 1)
    },
    "BACK_PAGE"(state) {
      state.currentPage--
      state.offset = state.limite * (state.currentPage - 1)
    },
    "RESET_PAGES"(state) {
      state.limite = 40
      state.offset = 0
      state.currentPage = 1
    },
    "SET_ISLOADING"(state, payload){
      state.isLoading = payload
    }
  },
  actions: {
    async getVouchers({commit, dispatch}) {
      commit("SET_ISLOADING", true)
      try {
        const query = await dispatch("createQuery")
        const {data} = await this._vm.$axios.get(URL_VENTA_VOUCHER + query + "&ordenar_por=createdAt&orden=desc")
        commit("SET_VOUCHERS", data.items)
        commit("SET_ISLOADING", false)
      } catch (e) {
        this._vm.$swal("Error!", e, "error")
        commit("SET_ISLOADING", false)
        console.log(e)
      }
    },
    nextPage({commit, dispatch}) {
      commit("NEXT_PAGE")
      dispatch("getVouchers")
      window.scrollTo({top: 200, behavior:"smooth"})
    },
    backPage({commit, dispatch}) {
      commit("BACK_PAGE")
      dispatch("getVouchers")
      window.scrollTo({top: 200, behavior:"smooth"})
    },
    resetPages({commit, dispatch}){
      commit("RESET_PAGES")
      dispatch("getVouchers")
    },
    async createQuery({state, dispatch}) {
      let _query = await dispatch("arrayCreate")
      return makeQuery({
        filtros: _query,
        limite: state.limite,
        offset: state.offset
      })
    },


    arrayCreate({state}) {
      let filtros = []
      const newObj = cleanObj(state.filtros)
      Object.keys(newObj).forEach(item => {
        let operator = typeof newObj[item] === "number" ? "=" : "CONTAINS"
        let field = item === "vendedor" ? "vendedor.nombre" : item
        filtros.push({field: field, value: newObj[item], operator: operator})
      })
      return filtros
    },


  },
  getters: {
    vouchers: state => state.vouchers,
    currentPage: state => state.currentPage,
    isLoading: state => state.isLoading
  }
}
